import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {usePartners} from '../../../../entities';

interface DeletePartnerModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  partnerId: string | null;
  onSuccess?: () => void;
}

export const DeletePartnerModal = ({open, setOpen, partnerId, onSuccess}: DeletePartnerModalProps) => {
  const {deletePartnerMutation} = usePartners();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление партнера',
  });

  useEffect(() => {
    if (deletePartnerMutation.error) {
      handleError(deletePartnerMutation.error as unknown as ApiError);
    }
  }, [deletePartnerMutation.error, handleError]);

  const handleSubmit = () => {
    if (partnerId) {
      deletePartnerMutation.mutate(partnerId, {
        onSuccess: () => {
          setOpen(false);
          if (onSuccess) {
            onSuccess();
          }
        },
      });
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deletePartnerMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление партнера'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этого партнера? Обратите внимание, что это действие безвозвратное.
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
